import { useEmailVerification } from '../hooks/useEmailVerification.js';
import { ResendLink } from './ConfirmEmailNotice.jsx';

/**
 * Shown on dashboards until the account's email is confirmed. Publishing
 * (programs and profiles) is blocked until then; drafts and applying are not.
 * Application results, payout notices and password resets go to this address,
 * so it is worth knowing it works.
 */
export function VerifyEmailBanner() {
  // Re-checking when the person comes back to the tab lives in AuthProvider,
  // so every notice clears together, not just this banner.
  const { user, verified, state, resend } = useEmailVerification();

  if (!user || verified) return null;

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-caution/30 bg-caution-soft px-4 py-3 text-sm">
      <p className="text-ink">
        <strong>Confirm your email to publish.</strong> We sent a link to {user.email}. Until you
        confirm, you can save drafts and apply to programs, but nothing you publish goes live.
      </p>
      <ResendLink state={state} resend={resend} />
    </div>
  );
}
